<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clipbox)">
      <path
          d="M15.9212 8.20917L14.1883 5.65669L15.9212 3.10421C16.0022 2.98246 16.0219 2.8305 15.9748 2.69225C15.9272 2.554 15.8182 2.4455 15.6795 2.39975L10.0233 0.524763C9.82096 0.456545 9.60215 0.533451 9.48497 0.70923L7.99998 2.93668L6.51499 0.70923C6.3969 0.532544 6.17624 0.456076 5.97665 0.524763L0.320445 2.39975C0.181758 2.44553 0.0727905 2.55403 0.0251971 2.69225C-0.0219588 2.8305 -0.00227145 2.98246 0.0787592 3.10424L1.81168 5.65672L0.0787904 8.20917C-0.0022402 8.33092 -0.0219275 8.48292 0.0252283 8.62117C0.0728217 8.75942 0.18179 8.86792 0.320476 8.91367L5.97668 10.7887C6.17574 10.8556 6.39718 10.7809 6.51502 10.6042L8.00001 8.37673L9.485 10.6042C9.60293 10.7811 9.82449 10.8556 10.0233 10.7887L15.6795 8.91367C15.8182 8.86789 15.9272 8.75939 15.9748 8.62117C16.0219 8.48292 16.0023 8.33095 15.9212 8.20917ZM8.00001 7.03777L3.85682 5.65672L8.00001 4.27567L12.1432 5.65672L8.00001 7.03777Z"
          fill="currentColor"/>
      <path
          d="M10.3199 11.6782C9.72988 11.8761 9.06282 11.6614 8.70488 11.1243L7.99998 10.0669L7.29499 11.1243C6.93777 11.6604 6.2715 11.877 5.67772 11.6772L1.90625 10.4202V13.1567C1.90625 13.3586 2.03534 13.5376 2.22668 13.6012L7.84889 15.4753C7.86583 15.4812 7.88277 15.4858 7.8997 15.4895C7.8997 15.4895 7.90017 15.4895 7.90017 15.4899H7.90064C7.93361 15.4968 7.96701 15.5005 7.99998 15.5005C8.03523 15.5005 8.07001 15.4964 8.10479 15.4886C8.12036 15.4849 8.13545 15.4808 8.15058 15.4758L13.7733 13.6012C13.9646 13.5376 14.0937 13.3586 14.0937 13.1567V10.4202L10.3199 11.6782Z"
          fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clipbox">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
  name: "IconBox"
}
</script>

<style scoped>

</style>